declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
  }
}

interface GA4Item {
  item_id: string;
  item_name: string;
  price: number;
  item_variant?: string;
  quantity: number;
}

function pushEvent(event: string, ecommerce: Record<string, unknown>) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({ event, ecommerce });
}

export function trackViewItem(product: {
  id: string;
  title: string;
  variants?: { edges: Array<{ node: { title: string; price: { amount: string; currencyCode: string } } }> };
  priceRange?: { minVariantPrice: { amount: string; currencyCode: string } };
}, selectedVariant?: { title: string; price: { amount: string; currencyCode: string } }) {
  const price = selectedVariant?.price ?? product.priceRange?.minVariantPrice;
  if (!price) return;

  const value = parseFloat(price.amount);
  pushEvent('view_item', {
    currency: price.currencyCode,
    value,
    items: [{
      item_id: product.id,
      item_name: product.title,
      price: value,
      item_variant: selectedVariant?.title,
      quantity: 1,
    }],
  });
}

export function trackAddToCart(product: {
  id: string;
  title: string;
}, variant: { title: string; price: { amount: string; currencyCode: string } }, quantity: number) {
  const value = parseFloat(variant.price.amount) * quantity;
  pushEvent('add_to_cart', {
    currency: variant.price.currencyCode,
    value,
    items: [{
      item_id: product.id,
      item_name: product.title,
      price: parseFloat(variant.price.amount),
      item_variant: variant.title,
      quantity,
    }],
  });
}

export function trackBeginCheckout(cartItems: Array<{
  product: { node: { id: string; title: string } };
  variantTitle: string;
  price: { amount: string; currencyCode: string };
  quantity: number;
}>) {
  if (cartItems.length === 0) return;

  const currency = cartItems[0].price.currencyCode;
  const items: GA4Item[] = cartItems.map(item => ({
    item_id: item.product.node.id,
    item_name: item.product.node.title,
    price: parseFloat(item.price.amount),
    item_variant: item.variantTitle,
    quantity: item.quantity,
  }));
  const value = items.reduce((sum, i) => sum + i.price * i.quantity, 0);

  pushEvent('begin_checkout', { currency, value, items });
}
